<template>
  <ul data-animate="list" class="page-catalogues-list__list">
    <li
      v-for="(catalogue, index) in catalogues"
      :key="catalogue.id"
      :class="{ 'm-top-4': index > 0 }"
    >
      <div class="page-catalogues-list__list__item">
        <PagesCataloguesListBlock :catalogue="catalogue" />
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PagesCataloguesList',
}
</script>

<script setup>
const props = defineProps({
  catalogues: Array,
})
</script>
